import {Component, EventEmitter, Input, Output, ViewChild, ElementRef, AfterViewInit, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {Option, OptionGroup} from '../../../shared/models/option';
import {CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition} from '@angular/cdk/overlay';
import {ClickService} from '../../../core/services/click.service';
import {Subscription} from 'rxjs';

/**
 * Button with dropdown menu - handles state management automatically.
 * For custom triggers or conditional menu switching, use <motn-popover-menu>.
 */
@Component({
  selector: 'motn-menu-button',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CdkOverlayOrigin,
    CdkConnectedOverlay,
  ],
})
export class MenuButtonComponent implements AfterViewInit, OnDestroy {
  @Input() buttonClass: string = '';
  @Input() menuTitle: string;
  @Input() optionsFactory: () => OptionGroup;
  @Input() overlayPositions: ConnectedPosition[] = [{
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
  }];

  @Output() optionSelected = new EventEmitter<Option>();

  @ViewChild('menuOverlay', {read: ElementRef}) menuEl: ElementRef<HTMLElement>;

  menuOpen = false;
  currentOptions: OptionGroup | null = null;

  private clickSub: Subscription;

  constructor(
    private eRef: ElementRef,
    private clickService: ClickService,
  ) {}

  ngAfterViewInit(): void {
    this.clickSub = this.clickService.click$.subscribe(
      ($el) => {
        if (this.menuOpen && this.eRef.nativeElement && !this.eRef.nativeElement.contains($el)) {
          this.closeMenu();
        }
      },
    );
  }

  ngOnDestroy(): void {
    this.clickSub?.unsubscribe();
  }

  toggleMenu(): void {
    if (this.menuOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  private openMenu(): void {
    if (this.optionsFactory) {
      this.currentOptions = this.optionsFactory();
      this.menuOpen = true;
    }
  }

  closeMenu(): void {
    this.menuOpen = false;
    this.currentOptions = null;
  }

  onOptionClick(option: Option): void {
    if (option.callback) {
      option.callback();
    }
    this.optionSelected.emit(option);
    this.closeMenu();
  }
}
